import { InjectionToken } from '@angular/core';

export const CalculateAge = new InjectionToken('_calculateAge');

export function _calculateAge(birthday: Date) { // birthday is a date
	const ageDifMs = Date.now() - birthday.getTime();
	const ageDate = new Date(ageDifMs); // miliseconds from epoch
	return Math.abs(ageDate.getUTCFullYear() - 1970);
}
